if (!customElements.get('custom-bundle')) {
  customElements.define('custom-bundle', class CustomBundle extends HTMLElement {
    constructor() {
      super();
      this.quantitySelectors = this.querySelectorAll(".custom-quantity-wrapper-item input");
      this.button = this.querySelector(".product-form__submit-bundle");
       this.miniCart = document.querySelector('mini-cart');
      this.initEventListeners();
    }
    initEventListeners(){
        this.quantitySelectors.forEach((el) => {
            el.addEventListener("change",this.onQuanityChange.bind(this));
        });
        this.button.addEventListener("click",this.onBundleAdd.bind(this));
        document.addEventListener('variant:change',this.updatePacks.bind(this));
        this.updatePacks();

    }
    updateState(currentSelectedVariant){
        if(currentSelectedVariant.available){
            this.querySelectorAll(".custom-quantity-wrapper-item").forEach(async (el) => {
                const quanityElement = el.querySelector("input");
                const pack = +quanityElement.dataset.pack;
                const isPack = quanityElement.dataset.ispack;
                 if(pack > 0 && isPack === 'true'){
                    const matchedGiftProducts = await this.findSimilarGiftProducts(currentSelectedVariant,pack);
                    console.log(matchedGiftProducts,"matchedGiftProducts", currentSelectedVariant,pack);
                    if(matchedGiftProducts.length > 0){
                        const findUnavailableVariants = matchedGiftProducts.filter(v => v.available == false);
                        if(findUnavailableVariants.length > 0){
                             el.classList.add("disabled");
                             console.log("ddd",el.querySelector("input:checked"));
                             if(el.querySelector("input:checked")){
                                this.button.disabled = true;
                                this.button.textContent = this.button.dataset.soldtext;
                             }
                        }else{
                            el.classList.remove("disabled");
                        }
                        
                    }else{
                        if(el.querySelector("input:checked")){
                        this.button.disabled = true;
                        this.button.textContent = this.button.dataset.soldtext;
                        }
                        el.classList.add("disabled")
                    }
                }else{
                    el.classList.remove("disabled")
                }
            });
            

        }else{
            this.button.disabled = true;
            this.button.textContent = this.button.dataset.soldtext;
            this.querySelectorAll(".custom-quantity-wrapper-item").forEach(el => el.classList.add("disabled"));
        }
    }
    updatePacks(){
        this.selectedMainVariantId = this.getSelectedMainVariantId();
        const selectedMainVariant = window.bundleMainProduct.variants.filter((variant) =>{
            return variant.id == this.selectedMainVariantId;
        });
        this.updateState(selectedMainVariant[0]);
    }
    getSelectedQuantityElement(){
        return this.querySelector(".custom-quantity-wrapper-item input:checked");
    }
    getSelectedMainVariantId(){
        return document.querySelector(`#${this.dataset.formid} input[name="id"]`).value;
    }
    onQuanityChange(evt){
        this.button.disabled = false;
        this.button.textContent = this.button.dataset.atctext;
        const parentElement = evt.target.parentElement;
        const productInfoWrapper = document.querySelector(".product__info-container");
        const regular_price_element = productInfoWrapper.querySelector(`s.price-item.price-item--regular price-money span`);
        const sale_price_element = productInfoWrapper.querySelector(`span.price-item.price-item--sale price-money span`);
        if(parentElement.querySelector("span.custom-quantity-price.line-through") && regular_price_element){
            regular_price_element.textContent = parentElement.querySelector("span.custom-quantity-price.line-through").textContent;
        }
        if(parentElement.querySelector("span.custom-quantity-price.sprice") && sale_price_element){
            sale_price_element.textContent = parentElement.querySelector("span.custom-quantity-price.sprice").textContent;
        }
    }
    findSimilarGiftProducts(mainProductVariant,pack){
        let products = [];
        /*for (let in window.bunldeGiftProducts){
            if(window.bunldeGiftProducts[i].variants.length > 0){
                const matchedItem = window.bunldeGiftProducts[i].variants.filter((variant) => {
                    return variant.option1 == mainProductVariant.option1;
                });
                if(matchedItem.length > 0){
                     products.push(matchedItem[0]);
                }else{
                     products.push(window.bunldeGiftProducts[i].variants[0]);
                }
            }else{
                products.push(window.bunldeGiftProducts[i].variants[0]);
            }
            
        }*/
       if(pack == 1){
        window.bundleGiftProducts.forEach(product => {
            const variants = product.variants;
            
            if (variants && variants.length > 0) {
                const selectedVariant = variants.find(variant => 
                    variant.option1 === mainProductVariant.option1
                ) || variants[0];
                
                if(selectedVariant){
                    products.push(selectedVariant);
                }
            }
        });
       }else if(pack == 2){
            window.bundlePack2GiftProducts.forEach(product => {
                const variants = product.variants;
                
                if (variants && variants.length > 0) {
                    const selectedVariant = variants.find(variant => 
                        variant.option1 === mainProductVariant.option1
                    )|| variants[0];
                    
                    if(selectedVariant){
                        products.push(selectedVariant);
                    }
                }
            });
       }else if(pack == 3){
            window.bundlePack3GiftProducts.forEach(product => {
                const variants = product.variants;
                
                if (variants && variants.length > 0) {
                    const selectedVariant = variants.find(variant => 
                        variant.option1 === mainProductVariant.option1
                    )|| variants[0];
                    if(selectedVariant){
                        products.push(selectedVariant);
                    }
                    
                }
            });
       }
       else if(pack == 4){
            window.bundlePack4GiftProducts.forEach(product => {
                const variants = product.variants;
                
                if (variants && variants.length > 0) {
                    const selectedVariant = variants.find(variant => 
                        variant.option1 === mainProductVariant.option1
                    )|| variants[0];
                    
                   if(selectedVariant){
                        products.push(selectedVariant);
                    }
                }
            });
       }else if(pack == 5){
            window.bundlePack5GiftProducts.forEach(product => {
                const variants = product.variants;
                
                if (variants && variants.length > 0) {
                    const selectedVariant = variants.find(variant => 
                        variant.option1 === mainProductVariant.option1
                    )|| variants[0];
                    
                    if(selectedVariant){
                        products.push(selectedVariant);
                    }
                }
            });
       }
       
        return products;
    }
    async onBundleAdd(evt){
        evt.preventDefault();
        this.selectedMainVariantId = this.getSelectedMainVariantId();
        this.button.setAttribute('disabled', true);
        this.button.classList.add('loading');
        const selectedMainVariant = window.bundleMainProduct.variants.filter((variant) =>{
            return variant.id == this.selectedMainVariantId;
        });
        const selectedQuantityElement = this.getSelectedQuantityElement();
        const selectedQuantity = +selectedQuantityElement.value;
        const pack = +selectedQuantityElement.dataset.pack;
        const isPack = selectedQuantityElement.dataset.ispack;
        
        if(selectedMainVariant.length > 0 && selectedMainVariant[0].available ){
            let items = [];
            if(pack > 0 && isPack === 'true'){
                const matchedGiftProducts = await this.findSimilarGiftProducts(selectedMainVariant[0],pack);
                if(matchedGiftProducts.length > 0){
                     const bundleId = new Date().getTime(); 
                    for(let i in matchedGiftProducts){
                             items.push({
                                id:matchedGiftProducts[i].id,
                                quantity:1,
                                properties:{
                                    "_ismain":0,
                                    "_bundleid":bundleId
                                }
                            });
                    }
                    items.push({
                        id:this.selectedMainVariantId,
                        quantity:1,
                        properties:{
                            "_ismain":1,
                            "_bundleid":bundleId
                        }
                    });
                }else{
                    items.push({id:this.selectedMainVariantId,quantity:selectedQuantity});
                }
            }else{
                items.push({id:this.selectedMainVariantId,quantity:selectedQuantity});
            }
            console.log(items,"items");
           
            const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

            const body = JSON.stringify({
            items:items,
            sections: sections,
            sections_url: window.location.pathname
            });
            fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
            .then((response) => response.json())
            .then((response) => {
             
                if (response.status === 422) {
                    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                        detail: {
                        errorMessage: response.description
                        }
                    }));
                }
                else {
                    this.miniCart && this.miniCart.renderContents(response);
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                        detail: {
                        product: response
                        }
                    }));
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.button.classList.remove('loading');
                this.button.removeAttribute('disabled');
            });
        }else{
            this.button.classList.remove('loading');
            this.button.removeAttribute('disabled');
        }
    }
  });
}